__turbopack_context__.v({
  "alignLeft": "HolidayPackageSection-module__xNhW2q__alignLeft",
  "badgeBest": "HolidayPackageSection-module__xNhW2q__badgeBest",
  "badgeEmi": "HolidayPackageSection-module__xNhW2q__badgeEmi",
  "badgeSeats": "HolidayPackageSection-module__xNhW2q__badgeSeats",
  "body": "HolidayPackageSection-module__xNhW2q__body",
  "card": "HolidayPackageSection-module__xNhW2q__card",
  "cardImage": "HolidayPackageSection-module__xNhW2q__cardImage",
  "cardIncludes": "HolidayPackageSection-module__xNhW2q__cardIncludes",
  "cardSubtitle": "HolidayPackageSection-module__xNhW2q__cardSubtitle",
  "cardTimer": "HolidayPackageSection-module__xNhW2q__cardTimer",
  "cardTitle": "HolidayPackageSection-module__xNhW2q__cardTitle",
  "discountTag": "HolidayPackageSection-module__xNhW2q__discountTag",
  "duration": "HolidayPackageSection-module__xNhW2q__duration",
  "flightSubTextTip": "HolidayPackageSection-module__xNhW2q__flightSubTextTip",
  "footer": "HolidayPackageSection-module__xNhW2q__footer",
  "footerContent": "HolidayPackageSection-module__xNhW2q__footerContent",
  "header": "HolidayPackageSection-module__xNhW2q__header",
  "headingBlock": "HolidayPackageSection-module__xNhW2q__headingBlock",
  "imageLink": "HolidayPackageSection-module__xNhW2q__imageLink",
  "imageWrap": "HolidayPackageSection-module__xNhW2q__imageWrap",
  "includeIcon": "HolidayPackageSection-module__xNhW2q__includeIcon",
  "inclusion": "HolidayPackageSection-module__xNhW2q__inclusion",
  "locationLine": "HolidayPackageSection-module__xNhW2q__locationLine",
  "nightsBadge": "HolidayPackageSection-module__xNhW2q__nightsBadge",
  "oldPrice": "HolidayPackageSection-module__xNhW2q__oldPrice",
  "perPerson": "HolidayPackageSection-module__xNhW2q__perPerson",
  "price": "HolidayPackageSection-module__xNhW2q__price",
  "priceBlock": "HolidayPackageSection-module__xNhW2q__priceBlock",
  "rating": "HolidayPackageSection-module__xNhW2q__rating",
  "section": "HolidayPackageSection-module__xNhW2q__section",
  "slickSlide": "HolidayPackageSection-module__xNhW2q__slickSlide",
  "slickWrap": "HolidayPackageSection-module__xNhW2q__slickWrap",
  "slider": "HolidayPackageSection-module__xNhW2q__slider",
  "soldOutBtn": "HolidayPackageSection-module__xNhW2q__soldOutBtn",
  "soldOutCard": "HolidayPackageSection-module__xNhW2q__soldOutCard",
  "soldOutImage": "HolidayPackageSection-module__xNhW2q__soldOutImage",
  "starting": "HolidayPackageSection-module__xNhW2q__starting",
  "titleLink": "HolidayPackageSection-module__xNhW2q__titleLink",
  "titleRow": "HolidayPackageSection-module__xNhW2q__titleRow",
  "viewAll": "HolidayPackageSection-module__xNhW2q__viewAll",
  "viewDealsBtn": "HolidayPackageSection-module__xNhW2q__viewDealsBtn",
});
